export const staff = {
  staff_name: "名前orニックネーム",
  company_name: "企業名",
  shop_name: "所属名",
  index: {
    staff_management: 'メンバー検索'
  },
  form: {
    btn_redirect: '変更する',
    input_labels: {
      id: 'メンバーコード',
      company: '企業名',
      shop: '所属名',
      occupation: '職種（例）ホール、キッチン、等',
      name: '名前',
      nickname: 'ニックネーム（チップ送付時に表示されます）',
      avatar: 'プロフィール写真',
      birthday: '生年月日',
      gender: '性別',
      mail_address: 'メールアドレス',
      login_id: 'ログインID (半角英数字8文字以上)',
      status: '有効・無効',
      description: '自己紹介文（お勧めメニュー、お勧めポイント、店舗やチームの特徴、\n趣味、個人SNS情報など、出来るだけ多くのを入力してください）',
      message_text: '返信メッセージ（ココロン受取時に相手に表示されます。\nまた来たくなるような、応援してよかったなと思えるような\n感謝のメッセージを入力してください）',
      order_number: '表示順',
    },
    input_placeholder: {
      company: '企業を選択してください',
      shop: '所属を選択してください',
      occupation: '職種',
      first_name: '姓',
      last_name: '名',
      nickname: 'ニックネーム',
      mail_address: 'メールアドレス',
      avatar: 'プロフィール写真',
      year: '西暦',
      month: '月',
      day: '日',
      login_id: 'ログインID',
      status: '有効・無効',
      description: '自己紹介文',
      message_text: '返信メッセージ',
      order_number: '表示順',
    },
  },
  detail_fields: {
    staff_id: 'メンバーコード',
    company_name: '企業名',
    shop_name: '所属名',
    occupation: '職種',
    nickname: 'ニックネーム',
    birthday: '生年月日',
    gender: '性別',
    mail_address: 'メールアドレス',
    register_date: '初回登録日',
    last_login_date: '最終ログイン日',
    login_id: 'ログインID',
    password: 'パスワード',
    status: '有効・無効',
    description: '自己紹介文',
    message_text: '返信メッセージ',
    order_number: '表示順',
  },
  earn_kokoron_detail: {
    title: '獲得ココロン詳細',
    close: 'とじる▲',
    open: '開く▼',
    open_show_poin: 'ひらく▼',
  },
  box_search_date: {
    start_date: '開始日',
    end_date: '終了日',
    year: '年',
    month: '月',
    day: '日'
  },
  account_info: 'アカウント情報',
  description_reply: '自己紹介・返信メッセージ',
}
